import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { environment } from '@env/environment';
import { AuthenticationMethod } from '@app/models';
import { EnterpriseService, PhoneOtpProviderService } from '@app/services';

export type ModalResult = {
  option: AuthenticationMethod;
  additionalInfo: AdditionalInfo;
};
export interface AdditionalInfo {
  content?: {
    name: string;
  };
}
export interface ModalPublicProperties {
  blockDismiss: boolean;
}

@Component({
  selector: 'app-pre-login-modal',
  templateUrl: './pre-login-modal.component.html',
  styleUrls: ['./pre-login-modal.component.scss'],
  standalone: false
})
export class PreLoginModalComponent implements ModalPublicProperties {
  @Input() blockDismiss = false;
  readonly Result = AuthenticationMethod;
  readonly isElectron = environment.electron;

  constructor(
    public modal: NgbActiveModal,
    public enterpriseService: EnterpriseService,
    public phoneOtpProvider: PhoneOtpProviderService
  ) {}

  emit(option: AuthenticationMethod, additionalInfo?: AdditionalInfo) {
    this.modal.close({ option, additionalInfo } as ModalResult);
  }
}
